import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const toSchemaJson = (schemaJson) => {
  if (!schemaJson) return undefined;
  return {
    title: schemaJson.title,
    type: schemaJson.type,
    additional_properties: schemaJson.additionalProperties,
    properties: schemaJson.properties,
    required: schemaJson.required || [],
    x_ui_groups: schemaJson.xUiGroups || [],
    x_ui_actions: schemaJson.xUiActions || []
  };
};

const normalizeJob = (entry) => {
  const job = entry.job || entry;
  return {
    job_id: entry.job_id || job.id || job.job_id || job.jobId || '',
    task_type: entry.task_type ?? job.task_type ?? job.taskType ?? job.user_params?.task_type ?? job.user_params?.taskType ?? null,
    status: entry.status ?? job.status ?? null,
    instance_id: entry.instance_id || job.instance_id || job.instanceId || '',
    created_at: entry.created_at || job.created_at || job.createdAt || '',
    updated_at: entry.updated_at || job.updated_at || job.updatedAt || ''
  };
};

export const testApi = async (request, token) => {
  console.log(`Attempting to call testApi with request: ${request} and token: ${token}`);
  console.log(BASE_URL);
  try {
    const response = await axios.get(`${BASE_URL}/vcai/v1/test-api`, {
      params: { request },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      }
    });
    console.log(`testApi call successful: ${response.data.response}`);
    return {
      success: true,
      response: response.data.response
    };
  } catch (error) {
    console.error(`Error calling testApi: ${error}`);
    return handleError(error);
  }
};

export const deployModel = async ({
  ip,
  port,
  host,
  isSlurmNode,
  isSingleNode,
  dockerId,
  repository,
  name,
  tag,
  isAMD,
  isNVIDIA,
  gpuName,
  gpuIndices,
  model,
  token
}) => {
  try {
    const data = {
      server_address: {
        ip,
        port,
        host
      },
      nodeTypes: {
        is_slurm_node: isSlurmNode,
        is_single_node: isSingleNode
      },
      docker_image: {
        id: '',
        docker_id: dockerId,
        repository,
        name,
        tag
      },
      gpu_info: {
        is_AMD: isAMD,
        is_NVIDIA: isNVIDIA,
        gpu_name: gpuName,
        gpu_indices: gpuIndices
      },
      model
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/deploy-model`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      status: response.data.status,
      containerId: response.data.container_id,
      pid: response.data.pid,
      serverAddress: response.data.server_address,
      port: response.data.Port
    };
  } catch (error) {
    return handleError(error);
  }
};

export const launchTraining = async ({
  model,
  inputModel,
  outputModel,
  dataPath,
  epochs,
  accumulationSteps,
  saveSteps,
  learningRate,
  dtype,
  maxSteps,
  groupByLength,
  batchSize,
  optim,
  loggingSteps,
  weightDecay,
  maxGradNorm,
  warmupRatio,
  schedulerType,
  taskType,
  pushToHub,
  repoId,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  duration,
  token
}) => {
  try {
    const data = {
      training_data: {
        model,
        input_model: inputModel,
        output_model: outputModel,
        data_path: dataPath
      },
      training_config: {  
        epochs,
        accumulation_steps: accumulationSteps,
        save_steps: saveSteps,
        learning_rate: learningRate,
        dtype,
        max_steps: maxSteps,
        group_by_length: groupByLength,
        batch_size: batchSize,
        optim,
        logging_steps: loggingSteps,
        weight_decay: weightDecay,
        max_grad_norm: maxGradNorm,
        warmup_ratio: warmupRatio,
        scheduler_type: schedulerType,
        task_type: taskType,
        push_to_hub: pushToHub,
        repo_id: repoId
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      duration
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/launch-training`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      PID: response.data.PID,
      containerId: response.data.container_id,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const checkTraining = async ({
  ip,
  port,
  host,
  dockerCredentials,
  dockerImage,
  dockerContainer,
  dockerStatus,
  dockerArguments,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  jobId,
  userId,
  imageId,
  jobType,
  status,
  command,
  pid,
  createdAt,
  updatedAt,
  token
}) => {
  try {
    const params = {
      server_address: {
        ip,
        port,
        host
      },
      docker: {
        docker_credentials: dockerCredentials,
        docker_image: dockerImage,
        docker_container: dockerContainer,
        docker_status: dockerStatus,
        docker_arguments: dockerArguments
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      job: {
        id: jobId,
        user_id: userId,
        image_id: imageId,
        job_type: jobType,
        status,
        command,
        pid,
        created_at: createdAt,
        updated_at: updatedAt
      }
    };

    const response = await axios.get(`${BASE_URL}/vcai/v1/check-training`, {
      params,
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const launchLatencyBenchmarking = async ({
  model,
  inputLen,
  outputLen,
  batchSize,
  maxModelLength,
  dtype,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  duration,
  token
}) => {
  try {
    const data = {
      benchmarking_data: {
        model,
        input_len: inputLen,
        output_len: outputLen,
        batch_size: batchSize,
        max_model_length: maxModelLength,
        dtype
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      duration
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/launch-latency-benchmarking`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      PID: response.data.PID,
      containerId: response.data.container_id,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const launchThroughputBenchmarking = async ({
  model,
  inputLen,
  outputLen,
  batchSize,
  maxModelLength,
  dtype,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  duration,
  token
}) => {
  try {
    const data = {
      benchmarking_data: {
        model,
        input_len: inputLen,
        output_len: outputLen,
        batch_size: batchSize,
        max_model_length: maxModelLength,
        dtype
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      duration
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/launch-throughput-benchmarking`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      PID: response.data.PID,
      containerId: response.data.container_id,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const launchInferencing = async ({
  ip,
  port,
  host,
  isSlurmNode,
  isSingleNode,
  model,
  inputModel,
  outputModel,
  dataPath,
  epochs,
  accumulationSteps,
  saveSteps,
  learningRate,
  dtype,
  maxSteps,
  groupByLength,
  batchSize,
  optim,
  loggingSteps,
  weightDecay,
  maxGradNorm,
  warmupRatio,
  schedulerType,
  taskType,
  pushToHub,
  repoId,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  duration,
  token
}) => {
  try {
    const data = {
      server_address: {
        ip,
        port,
        host
      },
      node_types: {
        is_slurm_node: isSlurmNode,
        is_single_node: isSingleNode
      },
      training_data: {
        model,
        input_model: inputModel,
        output_model: outputModel,
        data_path: dataPath
      },
      training_config: {
        epochs,
        accumulation_steps: accumulationSteps,
        save_steps: saveSteps,
        learning_rate: learningRate,
        dtype,
        max_steps: maxSteps,
        group_by_length: groupByLength,
        batch_size: batchSize,
        optim,
        logging_steps: loggingSteps,
        weight_decay: weightDecay,
        max_grad_norm: maxGradNorm,
        warmup_ratio: warmupRatio,
        scheduler_type: schedulerType,
        task_type: taskType,
        push_to_hub: pushToHub,
        repo_id: repoId
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      duration
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/launch-inferencing`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      PID: response.data.PID,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const checkInferencing = async ({
  ip,
  port,
  host,
  dockerCredentials,
  dockerImage,
  dockerContainer,
  dockerStatus,
  dockerArguments,
  instanceId,
  timeStart,
  timeEnd,
  numOfInstances,
  numOfGpusPerInstance,
  gpuInfo,
  cpuInfo,
  jobId,
  userId,
  imageId,
  jobType,
  status,
  command,
  pid,
  createdAt,
  updatedAt,
  token
}) => {
  try {
    const params = {
      server_address: {
        ip,
        port,
        host
      },
      docker: {
        docker_credentials: dockerCredentials,
        docker_image: dockerImage,
        docker_container: dockerContainer,
        docker_status: dockerStatus,
        docker_arguments: dockerArguments
      },
      instance: {
        instance_id: instanceId,
        time_start: timeStart,
        time_end: timeEnd,
        num_of_instances: numOfInstances,
        num_of_gpus_per_instance: numOfGpusPerInstance,
        gpu_info: gpuInfo,
        cpu_info: cpuInfo
      },
      job: {
        id: jobId,
        user_id: userId,
        image_id: imageId,
        job_type: jobType,
        status,
        command,
        pid,
        created_at: createdAt,
        updated_at: updatedAt
      }
    };

    const response = await axios.get(`${BASE_URL}/vcai/v1/check-inferencing`, {
      params,
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const pioChatBot = async (question, token) => {
  try {
    const data = { question };
    
    const response = await axios.post(`${BASE_URL}/vcai/public/v1/pio-chat-bot`, data);
    
    return {
      success: true,
      status: response.data.status,
      answer: response.data.answer
    };
  } catch (error) {
    return handleError(error);
  }
};

export const modelQueries = async ({
  question,
  port,
  ipAddress,
  hostname,
  token
}) => {
  try {
    const data = {
      question,
      port,
      server_address: {
        ip: ipAddress,
        port,
        host: hostname
      }
    };

    const response = await axios.post(`${BASE_URL}/vcai/v1/model-queries`, data, {
      headers: { 'Authorization': 'Bearer ' + token }
    });
    
    return {
      success: true,
      status: response.data.status,
      answer: response.data.answer
    };
  } catch (error) {
    return handleError(error);
  }
};

export const launchTrainingV2 = async ({
  trainingData,
  trainingConfig,
  instanceId,
  instanceConfig,
  duration,
  token
}) => {
  try {
    const data = {
      training_data: {
        input_model_path: trainingData?.inputModelPath,
        output_model_path: trainingData?.outputModelPath,
        dataset_path: trainingData?.datasetPath
      },
      training_config: {
        epochs: trainingConfig?.epochs,
        accumulation_steps: trainingConfig?.accumulationSteps,
        save_steps: trainingConfig?.saveSteps,
        learning_rate: trainingConfig?.learningRate,
        max_steps: trainingConfig?.maxSteps,
        group_by_length: trainingConfig?.groupByLength,
        batch_size: trainingConfig?.batchSize,
        logging_steps: trainingConfig?.loggingSteps,
        weight_decay: trainingConfig?.weightDecay,
        max_gradient_norm: trainingConfig?.maxGradientNorm,
        warmup_ratio: trainingConfig?.warmupRatio,
        data_type: trainingConfig?.dataType,
        optimizer_type: trainingConfig?.optimizerType,
        scheduler_type: trainingConfig?.schedulerType
      }
    };

    if (instanceId) {
      data.instance_id = instanceId;
    } else if (instanceConfig) {
      data.instance_config = {
        gpu_details: instanceConfig?.gpuDetails,
        framework: instanceConfig?.framework,
        driver_version: instanceConfig?.driverVersion,
        os_name: instanceConfig?.osName,
        os_version: instanceConfig?.osVersion,
        region: instanceConfig?.region
      };
    }

    if (duration) {
      data.duration = duration;
    }

    const response = await axios.post(`${BASE_URL}/vcai/v1/launch-training`, data, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });
    
    return {
      success: true,
      jobId: response.data.job_id || response.data.jobId
    };
  } catch (error) {
    return handleError(error);
  }
};

export const deployModelV2 = async ({
  modelPath,
  deploymentConfig,
  instanceId,
  instanceConfig,
  duration,
  token
}) => {
  try {
    const data = {
      model_path: modelPath,
      deployment_config: {
        port: deploymentConfig?.port
      }
    };

    if (instanceId) {
      data.instance_id = instanceId;
    } else if (instanceConfig) {
      data.instance_config = {
        gpu_details: instanceConfig?.gpuDetails,
        framework: instanceConfig?.framework,
        driver_version: instanceConfig?.driverVersion,
        os_name: instanceConfig?.osName,
        os_version: instanceConfig?.osVersion,
        region: instanceConfig?.region
      };
    }

    if (duration) {
      data.duration = duration;
    }

    const response = await axios.post(`${BASE_URL}/vcai/v1/deploy-model`, data, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });
    
    return {
      success: true,
      deploymentId: response.data.deployment_id || response.data.deploymentId,
      endpointUrl: response.data.endpoint_url || response.data.endpointUrl,
      status: response.data.status
    };
  } catch (error) {
    return handleError(error);
  }
};

export const addJobWorkload = async ({
  taskType,
  framework,
  userParams,
  token
}) => {
  try {
    const data = {
      task_type: taskType,
      framework,
      user_params: {}
    };

    if (userParams?.gpuDetails) {
      data.user_params.gpu_details = {
        num_of_gpus: userParams.gpuDetails.numOfGpus,
        gpu_model: userParams.gpuDetails.gpuModel,
        gpu_vendor: userParams.gpuDetails.gpuVendor
      };
    }

    if (userParams?.schemaJson) {
      data.user_params.schema_json = toSchemaJson(userParams.schemaJson);
    }

    const response = await axios.post(`${BASE_URL}/vcai/v1/workload`, data, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });
    
    return {
      success: response.data.success !== false,
      jobId: response.data.job_id || response.data.jobId
    };
  } catch (error) {
    return handleError(error);
  }
};

export const abortJobWorkload = async ({
  jobId,
  token
}) => {
  try {
    const data = { job_id: jobId };

    const response = await axios.post(`${BASE_URL}/vcai/v1/workload/abort`, data, {
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    return {
      success: response.data.success !== false,
      jobId: response.data.job_id || response.data.jobId
    };
  } catch (error) {
    return handleError(error);
  }
};

export const getJobsByUserId = async ({
  userId,
  token
}) => {
  try {
    const response = await axios.get(`${BASE_URL}/vcai/v1/workload/user`, {
      params: userId ? { user_id: userId } : undefined,
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    });

    const jobEntries = response.data.user_jobs || response.data.jobs || [];
    const jobs = jobEntries.map(normalizeJob);

    return {
      success: response.data.success !== false,
      jobs
    };
  } catch (error) {
    return handleError(error);
  }
};

const handleError = (error) => {
  console.error('VCAI API Error:', error);
  
  if (error.response?.status === 503) {
    return {
      success: false,
      error: 'Service temporarily unavailable'
    };
  }
  
  return {
    success: false,
    error: error.response?.data?.message || error.message || 'Operation failed'
  };
};